import React, {Component} from 'react'

import MS from './../services/Moment'

import { DatePicker } from 'element-react';
import 'element-theme-default';

import { i18n } from 'element-react'
import locale from 'element-react/src/locale/lang/ko'
import { withTranslation } from 'react-i18next';

i18n.use(locale);

class DateCustom extends Component {
    constructor(props) {
        super(props);
        this.state = {
          value2: props.value ? MS.toDate(props.value, 'YYYY-MM-DD') : null // 초기 값 설정 시 null 처리
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
            value2: this.props.value ? MS.toDate(this.props.value, "YYYY-MM-DD") : null, // value가 없는 경우 null 처리
            });
        }
    }

    handleChange(dt) {
        if (!dt) {
            this.setState({ value2: null });
            this.props.handleDateChange(this.props.name, ""); // 빈 값 처리
            return;
        }
        this.setState({ value2: dt });
        this.props.handleDateChange(this.props.name, MS.format(dt, 'YYYY-MM-DD'));
    }
    

    render() {
        const {value2} = this.state
        const { t } = this.props;
        return (
            <>
                <DatePicker
                    name={this.props.name}
                    value={value2 || null}
                    placeholder={t('key423')}
                    align="right"
                    ref={e=>this.datepicker2 = e}
                    onChange={date => this.handleChange(date)}
                    shortcuts = {
                        [
                            {
                                text: t('key586'),
                                onClick: ()=> {
                                    const dt = new Date();
                                    dt.setTime(MS.add(dt, 5, 'Y'));
                                    if (dt) {
                                        this.setState({ value2: dt });
                                        this.datepicker2.togglePickerVisible();
                                        this.handleChange(dt);
                                    }
                                }
                            },
                            {
                                text: t('key587'),
                                onClick: ()=> {
                                    const dt = new Date();
                                    dt.setTime(MS.add(dt, 10, 'Y'));
                                    if (dt) {
                                        this.setState({ value2: dt });
                                        this.datepicker2.togglePickerVisible();
                                        this.handleChange(dt);
                                    }
                                }
                            },
                            {
                                text: t('key588'),
                                onClick: ()=> {
                                    const dt = new Date();
                                    dt.setTime(MS.add(dt, 15, 'Y'));
                                    if (dt) {
                                        this.setState({ value2: dt });
                                        this.datepicker2.togglePickerVisible();
                                        this.handleChange(dt);
                                    }
                                }
                            },
                            {
                                text: '20년후',
                                onClick: ()=> {
                                    const dt = new Date();
                                    dt.setTime(MS.add(dt, 20, 'Y'));
                                    if (dt) {
                                        this.setState({ value2: dt });
                                        this.datepicker2.togglePickerVisible();
                                        this.handleChange(dt);
                                    }
                                }
                            }
                        ]
                    }
                />
            </>
        )
    }
}

export default withTranslation()(DateCustom);
